import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {
  InteractionDocumentDto,
  UserInteractionDto,
  UserInteractionTypeDto,
  UserInteractionTypeOverviewDto
} from "../types/ds-interaction.types";
import {HttpEvent} from "@angular/common/http";
import {CoreApiService} from "../../core/service/core-api.service";
import {FormDto} from "../../core/interfaces/core.types";

@Injectable({ providedIn: 'root' })
export abstract class InteractionApiService {

  endPoint: string = "mvseu/eu/endUser/interaction"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public getInteractionType(id: number | "contactUs") : Observable<UserInteractionTypeDto> {

    if (id == "contactUs") {
      return this.coreApiService.get(`${this.endPoint}/typeViaAlias/${id}`);
    } else {
      return this.coreApiService.get(`${this.endPoint}/type/${id}`);
    }

  }

  public createInteraction(interactionTypeId: number, dto: FormDto | null, forceUpdate: boolean) : Observable<UserInteractionDto> {
    return this.coreApiService.post(dto, `${this.endPoint}?interactionTypeId=${interactionTypeId}&forceUpdate=${forceUpdate}`);
  }

  public createDocument(interactionId: number, dto: InteractionDocumentDto): Observable<HttpEvent<InteractionDocumentDto>> {
    //return this.coreApiService.create(dto, `/interaction/${interactionId}/document`);
    return this.coreApiService.post(dto, `${this.endPoint}/${interactionId}/document`);
  }

  public updateInteractionForm(interactionId: number, dto: FormDto) : Observable<UserInteractionDto> {
    return this.coreApiService.update(dto, `${this.endPoint}/${interactionId}/form`);
  }

  /**
   * Newly added replaces the updateInteraction
   * @param interactionId
   * @param scheduleTypeId
   * @param freeSlotId
   */
  public finalizeInteraction(interactionId: number, scheduleTypeId: number, freeSlotId?: string) : Observable<UserInteractionDto> {
    if (!scheduleTypeId && !freeSlotId) {
      return this.coreApiService.update({}, `${this.endPoint}/finalize/${interactionId}`);
    } else {
      return this.coreApiService.update({}, `${this.endPoint}/finalize/${interactionId}?scheduleTypeId=${scheduleTypeId}&freeSlotId=${freeSlotId}`);
    }

  }

  public getDocumentBinary(interactionId: number, documentId: number) : Observable<string> {
    return this.coreApiService.getDocumentBinary(`${this.endPoint}/${interactionId}/document/${documentId}/$`);
  }

  public deleteInteractionTypeDocument(interactionId: number, documentId: number): Observable<any> {
    return this.coreApiService.delete(`${this.endPoint}/${interactionId}/document/${documentId}`);
  }

  public getCustomerInteractionDocumentBinary(interactionId: number, documentId: number): Observable<any> {
    return this.coreApiService.get(`${this.endPoint}/${interactionId}/document/${documentId}/$`);
  }


  public getInteraction(id: number): Observable<UserInteractionDto> {
    return this.coreApiService.get(`${this.endPoint}/${id}`);
  }

  public getInteractionTypes() : Observable<UserInteractionTypeOverviewDto> {
    return this.coreApiService.get(`${this.endPoint}/types`);
  }




}
